import { createRouter, Router, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'

const Home: any = () => import('@/views/home/index.vue')
const Weather: any = () => import('@/views/weather/index.vue')
export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home',
    meta: {
      title: '首页',
      hideHeader: true
    }
  },
  {
    path: '/home',
    component: Home,
    name: 'home',
    meta: {
      title: '首页',
      hideHeader: true
    }
  },
  {
    path: '/weather',
    component: Weather,
    name: 'weather',
    meta: {
      title: '天气',
      hideHeader: true
    }
  }
]

export const asyncRoutes: Array<RouteRecordRaw> = [
  // ...permissionModules
]
const router = createRouter({
  history: createWebHistory('/sk/'),
  // history: createWebHashHistory('/sgh5/'),
  routes: constantRoutes
})

export function resetRouter() {
  const newRouter = router;
  (router as any).matcher = (newRouter as any).matcher // reset router
}

export default router
